/** Chart/table horizontal pagination page size for Price Pack Architecture. */
export const PPA_CHART_PAGE_LIMIT = 50;

/** Minimum spacing between KPI range min/max and adjacent breakpoints (sliders, inputs). */
export const KPI_RANGE_GAP = 1;

/** Minimum allowed uniform bin count and bin size in KPI axis configuration. */
export const MIN_KPI_BIN_COUNT = 1;

/** Fallback maximum allowed uniform bin count when backend meta has no override (PA-07). */
export const MAX_KPI_BIN_COUNT = 30;

/** Default number of uniform bins when KPI axis configuration has no meta override. */
export const DEFAULT_UNIFORM_BIN_COUNT = 5;

/** Maximum custom breakpoints allowed in KPI axis configuration. */
export const MAX_CUSTOM_BREAKPOINTS = 10;

/** Fallback min/max bounds for KPI axis configuration when chart meta is unavailable. */
export const DEFAULT_KPI_DATA_RANGE = {
    defaultMin: 0,
    defaultMax: 100,
} as const;

/** `id_type` value marking a KPI-typed axis/companion option (as opposed to `attribute_type`). */
export const OPTION_ID_TYPE_KPI = 'kpi_id';

/** `id_type` value marking an attribute-typed axis/sort option (as opposed to `kpi_id`). */
export const OPTION_ID_TYPE_ATTRIBUTE = 'attribute_type';

/**
 * Performance Summary top-level `feature_id`s — mirror the top-level node
 * `id`s in `client_config/performance_summary.json`.
 */
export const PS_FEATURE_ID_KPI_TILES = 'kpi_tiles';
export const PS_FEATURE_ID_OVERALL_PERFORMANCE = 'overall_performance';
export const PS_FEATURE_ID_PERFORMANCE_BY_LENS = 'performance_by_lens';

/** `id_type` value for Performance Summary's active-lens-tab sort/filter binding. */
export const PS_ID_TYPE_LENS = 'lens';

/** Navigation/editing keys allowed in KPI integer-only range inputs (PA-07). */
export const KPI_INTEGER_CONTROL_KEYS = new Set([
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Home',
    'End',
]);
